import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import 'vant/lib/toast/style';
import 'vant/lib/loading/style';
import 'vant/lib/dialog/style';
import 'vant/lib/list/style';
import 'vant/lib/notify/style';
import 'vant/lib/popup/style';
import 'vant/lib/picker/style';
import 'vant/lib/empty/style';
import 'vant/lib/icon/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/area/style';
import 'vant/lib/skeleton/style';
import 'vant/lib/goods-action/style';
import 'vant/lib/goods-action-button/style';
import 'vant/lib/search/style';
import 'vant/lib/pull-refresh/style';
import 'vant/lib/overlay/style';
import 'vant/lib/field/style';
import './assets/css/common.min.css'

import { Toast, Loading, Dialog, Popup, Empty,Icon,List,Cell,Button ,Swipe ,SwipeItem,Lazyload,Area,Skeleton,GoodsAction,GoodsActionButton,Search,PullRefresh,Overlay, Field} from 'vant';

Vue.use(Toast)
  .use(Loading)
  .use(Dialog)
  .use(Popup)
  .use(Empty)
  .use(Icon)
  .use(List)
  .use(Cell)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Area)
  .use(Skeleton)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(Search)
  .use(PullRefresh)
  .use(Overlay)
  .use(Field)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
